import { CounterBox } from "@/components/CounterBox";
import { Stack } from "@mui/material";

export function CountUpSection() {
  return (
    <Stack
      sx={{
        maxWidth: 1100,
        width: "100%",
        margin: "auto",
        flexDirection: {
          xs: "column",
          md: "row",
        },
        justifyContent: "center",
        alignItems: {
          xs: "center",
          md: "flex-start",
        },
        flexWrap: "wrap",
        gap: {
          xs: 3,
          sm: 5,
        },
      }}
    >
      <CounterBox
        end={700}
        prefix="+"
        label="clientes atendidos"
        description="Empresas de diferentes segmentos que confiam em nossas soluções."
      />

      <CounterBox
        end={90}
        prefix="+R$ "
        label="economizados todos os meses"
        description="Redução imediata de impostos pagos a maior."
        suffix="mil"
      />
      <CounterBox
        end={5}
        prefix="+R$ "
        label="em créditos tributários recuperados"
        description="Valores restituídos de forma segura e administrativa em empresas do simples nacional."
        suffix="milhões"
      />
    </Stack>
  );
}
